import { Button } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import { ReactComponent as GoogleLogo } from 'src/images/svgs/brands/google-full-color.svg';
import { ReactComponent as LinkedInLogo } from 'src/images/svgs/brands/linkedin.svg';
import styled from 'styled-components';

export const StyledLoginForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
`;

export const StyledFormControl = styled.div`
  margin-top: 0;
`;

export const StyledForgotPasswordButton = styled(Link)`
  margin-top: 1rem;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  display: block;
  text-decoration: none;
  :hover,
  :focus {
    text-decoration: underline;
  }
`;

export const StyledFullWidthButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
`;

export const StyledFullWidthButton = styled(Button)`
  width: 100%;
`;

export const StyledFullWidthLink = styled(Link)`
  width: 100%;
  text-decoration: none;
`;

export const StyledGoogleLogo = styled(GoogleLogo)`
  && {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

export const StyledLinkedInLogo = styled(LinkedInLogo)`
  && {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

export const StyledOrContainer = styled.span`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;

export const StyledOrLabel = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin: 0 1.4rem;
`;

export const StyledHorizontalRule = styled.hr`
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  height: 0;
  flex-grow: 1;
`;

export const StyledRegisterLink = styled(Link)`
  color: ${({ theme }) => theme.colors.success.toggle};
  text-decoration: none;
  :hover,
  :focus {
    text-decoration: underline;
  }
`;

export const StyledLoginButtonAndLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
`;

export const StyledTextWithLink = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.text.lighter};
`;
